import Lottie from 'lottie-react';

import dinner from '../jsons/Dinner.json';

const Dinner = props => {
  return <Lottie animationData={dinner} {...props} />;
};

export default Dinner;
